import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { InputWrapper, InputElement, Wrapper, CurrencyWrapper } from 'src/domains/layouts/shared/formComponents/input/Input.style';
import { InputError, InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormInputState, FormModel } from 'src_common/common/mobx-utils/Form';
import { InputStatus } from 'src/components/Input/InputStatus';
import { InputState } from 'src/components/Input/Input.state';

type InputType = 'button' | 'checkbox' | 'color' | 'date' | 'datetime-local' | 'email' | 'file' | 'hidden' | 'image' | 'month' | 'number' | 'password' | 'radio' | 'range' | 'reset' | 'search' | 'submit' | 'tel' | 'text' | 'time' | 'url' | 'week';

interface PropsType {
    className?: string,
    label?: string,
    placeholder?: string,
    inputType?: InputType,
    currency?: string,
    formInputState: FormInputState<string>,
    model: FormModel<string | number | null>,
    status?: InputStatus,
    readOnly?: boolean,
    min?: string,
    max?: string,
    step?: string,
    maxLength?: number,
    isDisabled?: boolean,
    autoFocus?: boolean,
    onChange?: (event: React.SyntheticEvent<HTMLInputElement>) => void,
    onBlur?: (event: React.SyntheticEvent<HTMLInputElement>) => void,
    dataTest?: string,
}

/**
 * @deprecated please use Input from src/domains/layouts/shared/formComponents/input/Input.tsx
 */

export const OldInput = observer('OldInput', (props: PropsType) => {
    const {
        className,
        label,
        placeholder,
        inputType,
        currency,
        formInputState,
        model,
        status,
        readOnly,
        maxLength,
        min,
        max,
        step,
        isDisabled,
        autoFocus,
        onChange,
        onBlur,
        dataTest
    } = props;

    const eventHandlers = {
        onChange,
        onBlur
    };

    const [ inputState ] = React.useState(() => new InputState(formInputState, model, eventHandlers));

    const hasCurrency = currency !== undefined && inputState.value.length > 0;

    const { type: statusType, message: statusMessage } = status || {};

    const renderErrorMessage = (): JSX.Element | null => {
        if (statusType === 'error' && statusMessage !== null) {
            return <InputError>{statusMessage}</InputError>;
        }
        return null;
    };

    return (
        <InputWrapper>
            <Wrapper>
                { label === undefined ? null : <InputLabel>{label}</InputLabel> }
                <>
                    {hasCurrency ? <CurrencyWrapper>{currency}</CurrencyWrapper> : null}
                    <InputElement
                        className={className}
                        placeholder={placeholder}
                        value={formInputState.value}
                        hasCurrency={hasCurrency}
                        type={inputType}
                        min={min}
                        max={max}
                        step={step}
                        readOnly={readOnly}
                        maxLength={maxLength}
                        disabled={isDisabled}
                        autoFocus={autoFocus}
                        onChange={inputState.handleChange}
                        onBlur={inputState.handleBlur}
                        data-test={dataTest}
                    />
                </>
            </Wrapper>
            {renderErrorMessage()}
        </InputWrapper>
    );
});
